import React from 'react';
const moment = require('moment')
import {OverlayTrigger, Tooltip,
	Button
} from 'react-bootstrap';

const Body = props => {
	let {
		data,
		schema,
		isLoading,
		handleModalShow,
		accessible,
		actionCustomId,
		customUpdate,
		customView,
		customDelete,
		customAction,
		customItems,
		getTableData,
		showButtonActionAsText
	} = props;

	var exclude = ['OBJECTID', 'CREATEDAT', 'UPDATEDAT']

	const isUndefined = (obj) => typeof obj === 'undefined'
		? true
		: false

	const TTview = (
		<Tooltip id="tooltip">View</Tooltip>
	);
	const TTupdate = (
		<Tooltip id="tooltip">Update</Tooltip>
	);
	const TTdelete = (
		<Tooltip id="tooltip">Delete</Tooltip>
	);

	actionCustomId = typeof actionCustomId !== 'undefined'
	? actionCustomId
	: '';

	console.log('calling body', actionCustomId)

	const renderActions = (obj) => {
		const isShow = (obj, actionType) => isUndefined(obj) || obj != false
			? {
				display: accessible(actionType) === ''
					? 'inline-block'
					: 'none'
			}
			: {
				display: 'none'
			};

		let _buttonView = (text="") => {
			let props = {
				style: isShow(schema.showView, 'VIEW'),
				onClick: () => (accessible('VIEW') === '') ? (typeof customView !== 'undefined' && typeof customView === 'function'
					? customView(obj)
					: handleModalShow('view', obj))
				: {},
				
			};

			if (text === "") {
				return (
					<a {...props} className={[ "fa fa-eye fa-lg", actionCustomId].join(" ")} href="javascript:void(0)">{text}</a>
				)
			} else {
				return (
					<Button {...props} className={actionCustomId}>{text}</Button>
				);
			}
		};

		let buttonView = showButtonActionAsText ? (
			_buttonView("View")
		) : (
			<OverlayTrigger placement="top" overlay={TTview}>
				{_buttonView()}
			</OverlayTrigger>
		);
		
		let _buttonUpdate = (text = "") => {
			let props = {
				style: isShow(schema.showUpdate, 'UPDATE'),
				onClick: () => (accessible('UPDATE') === '')
					? (typeof customUpdate !== 'undefined' && typeof customUpdate === 'function'
						? customUpdate(obj)
						: handleModalShow('update', obj))
					: {}
			};
			if (text === "") {
				return (
					<a {...props} className={[ "fa fa-pencil fa-lg", actionCustomId ].join(" ")} href="javascript:void(0)">{text}</a>
				)
			} else {
				return (
					<Button {...props} className={actionCustomId}>{text}</Button>
				)
			}
		};

		let buttonUpdate = showButtonActionAsText ? (
			_buttonUpdate("Update")
		) : (
			<OverlayTrigger placement="top" overlay={TTupdate}>
				{_buttonUpdate()}
			</OverlayTrigger>
		);

		let _buttonDelete = (text ="") => {
			let props = {
				style: isShow(schema.showDelete, 'DELETE'),
				onClick: () => (accessible('DELETE') === '')
					? (typeof customDelete !== 'undefined' && typeof customDelete === 'function'
						? customDelete(obj)
						: handleModalShow('delete', obj))
					: {}
			};

			if (text === "") {
				return (
					<a {...props} className={[ "fa fa-trash fa-lg" , actionCustomId].join(" ")} href="javascript:void(0)">{text}</a>
				)
			} else {
				return (
					<Button {...props} className={actionCustomId}>{text}</Button>
				)
			}
		};
		
		let buttonDelete = showButtonActionAsText ? (
			_buttonDelete("Delete")
		) :(
			<OverlayTrigger placement="top" overlay={TTdelete}>
				{_buttonDelete()}
			</OverlayTrigger>
		);

		return (
			<td>
				{!isUndefined(customAction) && typeof customAction === "function" ? (
					customAction({
            object: obj,
            buttonView,
            buttonUpdate,
            buttonDelete
          })
				) : (
					showButtonActionAsText ? (
						<p style={{ textAlign: "center" }}>
							{buttonView}
							{buttonUpdate}
							{buttonDelete}
						</p>
					) : (
						<span>
							{buttonView}
							{buttonUpdate}
							{buttonDelete}
						</span>
					)
				)}
			</td>
		)
	}

	const format = (obj, column) => {
		console.log('obj', obj)
		switch (column.type.toUpperCase()) {
			case 'STRING':
				return obj
					? obj // .toUpperCase()
					: ''
			case 'DATE':
				var format = isUndefined(column.format)
					? 'MMM-DD-YYYY'
					: column.format
				return obj
					? moment(obj).format(format).toUpperCase()
					: '';
			case 'POINTER':
				return obj
					? obj.get(column.displayColumn)
					: ''
			case 'NUMBER':
				return obj
					? obj
					: ''
			case 'BOOLEAN':
				return isUndefined(obj)
					? ''
					: obj.toString();
			case 'PARSEFILE':
				return isUndefined(obj)
					? ''
					: <div style={{
						maxWidth: '200px',
						maxHeight: '200px',
						height: '200px',
						width: '200px',
						display: 'table-cell',
						verticalAlign: 'middle',
						minWidth: '200px'
					}}><img src={obj.url()} width="100%"/>
					</div>;
			default:
				return obj
		}
	}

	const getTdStyle = (column) => isUndefined(column.style)
		? {
			whiteSpace: "nowrap",
			textAlign: column.type.toUpperCase() === 'NUMBER'
				? 'right'
				: 'auto'
		}
		: column.style

	const makeid = () => {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < 5; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}

	const renderTrueValue = (value, column, obj) => typeof customItems !== 'undefined' && customItems.length > 0 && customItems.map(e => e.columnName).indexOf(column.columnName) != -1
		? customItems[customItems.map(e => e.columnName).indexOf(column.columnName)].render({
			value: format(value, column),
			column,
			getTableData,
			object: obj
		}) : !isUndefined(column.render) && typeof column.render === "function" ?
		column.render({
			value: format(value, column),
			column,
			getTableData,
			object: obj
		})
		: format(value, column)

	const renderTd = (column, obj) => <td style={getTdStyle(column)} key={makeid()}>{renderTrueValue(obj.get(column.columnName), column, obj)}</td>

	const renderTr = (obj) => <tr key={obj.id}>{schema.columns.map((item) => (exclude.indexOf(item.columnName.toUpperCase()) == -1 || item.show) && item.show != false
			? renderTd(item, obj)
			: '')}{renderActions(obj)}</tr>

	return (
		<tbody>
			{isLoading
				? <tr>
						<td colSpan={(schema.columns.length - exclude.length) + 1} className="text-center">
							<i className="fa fa-spinner fa-3x fa-spin"></i>
						</td>
					</tr>
				: data.length != 0
					? data.map(renderTr)
					: <tr>
						<td colSpan={(schema.columns.length - exclude.length) + 1} className="text-center" style={{
							color: '#808080'
						}}>No Data Available</td>
					</tr>}
		</tbody>
	)
}

export default Body;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Table/Body.js